import { Navigate, Route, Routes } from 'react-router-dom';
import MainContainer from '@/containers/MainContainer';
import AdminContainer from '@/containers/AdminContainer';
import InventoryContainer from '@/containers/InventoryContainer';

export default function MainRoute() {
  return (
    <Routes>
      <Route path={'/'} element={<MainContainer />} />
      <Route path={'/login'} element={<MainContainer />} />
      <Route path={'/sign-up'} element={<MainContainer />} />
      <Route path={'/pricing'} element={<MainContainer />} />
      <Route path={'/refund-policy'} element={<MainContainer />} />

      <Route path={'/home'} element={<MainContainer />} />
      <Route path={'/devices'} element={<MainContainer />} />
      <Route path={'/fda/endorsement'} element={<MainContainer />} />
      <Route path={'/fda/signature'} element={<MainContainer />} />
      <Route path={'/projects'} element={<MainContainer />} />
      <Route path={'/alarm-history'} element={<MainContainer />} />
      <Route path={'/operation-log'} element={<MainContainer />} />
      <Route path={'/reports'} element={<MainContainer />} />
      <Route path={'/inventory-management'} element={<InventoryContainer />} />
      <Route path={'/setting/users'} element={<MainContainer />} />
      <Route path={'/setting/members'} element={<MainContainer />} />
      <Route path={'/setting/groups'} element={<MainContainer />} />
      <Route path={'/setting/subscription'} element={<MainContainer />} />

      <Route path="/admin">
        <Route index element={<AdminContainer />} />
        <Route path="main">
          <Route index element={<AdminContainer />} />
          <Route path="notice" element={<AdminContainer />} />
          <Route path="terms" element={<AdminContainer />} />
          <Route path="privacy" element={<AdminContainer />} />
        </Route>
        <Route path="users">
          <Route index element={<AdminContainer />} />
          <Route path="view" element={<AdminContainer />} />
          <Route path="view/detail" element={<AdminContainer />} />
          <Route path="leaved" element={<AdminContainer />} />
        </Route>
        <Route path="sites">
          <Route index element={<AdminContainer />} />
          <Route path="view" element={<AdminContainer />} />
          <Route path="members" element={<AdminContainer />} />
        </Route>
        <Route path="devices">
          <Route index element={<AdminContainer />} />
          <Route path="sensors" element={<AdminContainer />} />
          <Route path="gateways" element={<AdminContainer />} />
        </Route>
        <Route path="notifications">
          <Route index element={<AdminContainer />} />
          <Route path="push" element={<AdminContainer />} />
          <Route path="templates" element={<AdminContainer />} />
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
